enum ReportsMenuOptions {
  ALL_DASHBOARDS = "all-dashboards",
  UPGRADE_YOUR_REPORTS = "upgrade-your-reports",
  OVERVIEW = "overview",
}

export default ReportsMenuOptions;
